var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "modal-benefit-setting",
      "title": "新增簽到任務"
    }
  }, [_vm.isLoading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-3 mb-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "任務名稱"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "state": _vm.v$.form.name.$error ? false : null
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "使用期間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "by_checkin_campaign"
    },
    model: {
      value: _vm.form.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "period_type", $$v);
      },
      expression: "form.period_type"
    }
  }, [_vm._v(" 與簽到活動相同 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    staticClass: "mr-2",
    attrs: {
      "value": "custom"
    },
    model: {
      value: _vm.form.period_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "period_type", $$v);
      },
      expression: "form.period_type"
    }
  }, [_vm._v(" 自訂期限 ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.form.period_type !== 'custom'
    },
    model: {
      value: _vm.form.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "start_at", $$v);
      },
      expression: "form.start_at"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "language": _vm.zh,
      "format": "yyyy-MM-dd",
      "disabled": _vm.form.period_type !== 'custom'
    },
    model: {
      value: _vm.form.end_at,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "end_at", $$v);
      },
      expression: "form.end_at"
    }
  })], 1)], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "達成條件"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "streak_type"
    },
    model: {
      value: _vm.form.conditions.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.conditions, "type", $$v);
      },
      expression: "form.conditions.type"
    }
  }, [_vm._v(" 連續簽到 ")]), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: _vm.form.conditions.streak_days,
      callback: function callback($$v) {
        _vm.$set(_vm.form.conditions, "streak_days", $$v);
      },
      expression: "form.conditions.streak_days"
    }
  }), _c('span', [_vm._v("天")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.conditions.streak_days.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "total_type"
    },
    model: {
      value: _vm.form.conditions.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.conditions, "type", $$v);
      },
      expression: "form.conditions.type"
    }
  }, [_vm._v(" 累積簽到 ")]), _c('b-form-input', {
    staticClass: "mx-2",
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: _vm.form.conditions.total_days,
      callback: function callback($$v) {
        _vm.$set(_vm.form.conditions, "total_days", $$v);
      },
      expression: "form.conditions.total_days"
    }
  }), _c('span', [_vm._v("天")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.conditions.total_days.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('b-form-radio', {
    attrs: {
      "value": "period_type"
    },
    model: {
      value: _vm.form.conditions.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form.conditions, "type", $$v);
      },
      expression: "form.conditions.type"
    }
  }, [_vm._v(" 於 ")]), _c('div', {
    staticClass: "d-flex align-items-center mx-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "state": _vm.v$.period_start_at.date.$error ? false : null
    },
    model: {
      value: _vm.period_start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.period_start_at, "date", $$v);
      },
      expression: "period_start_at.date"
    }
  }), _c('div', {
    staticClass: "feedback-placeholder"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.period_start_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control'],
      "state": _vm.v$.period_start_at.time.HH.$error || _vm.v$.period_start_at.time.mm.$error ? false : null
    },
    model: {
      value: _vm.period_start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.period_start_at, "time", $$v);
      },
      expression: "period_start_at.time"
    }
  }), _c('div', {
    staticClass: "feedback-placeholder"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.period_start_at.time.HH.$error || !_vm.v$.period_start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1)]), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("~")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "state": _vm.v$.period_end_at.date.$error ? false : null
    },
    model: {
      value: _vm.period_end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.period_end_at, "date", $$v);
      },
      expression: "period_end_at.date"
    }
  }), _c('div', {
    staticClass: "feedback-placeholder"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.period_end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.period_start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.period_end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.period_end_at, "time", $$v);
      },
      expression: "period_end_at.time"
    }
  }), _c('div', {
    staticClass: "feedback-placeholder"
  }, [_c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.period_end_at.time.HH.$error || !_vm.v$.period_end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1)])]), _c('span', [_vm._v("簽到")])], 1)], 1)], 1), [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-2 ml-5",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.submitMissionSetting
    }
  }, [_vm._v(" 儲存 ")])], 1)])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }